import { FormlyFieldConfig } from '@ngx-formly/core';


export interface IQuestionGroupTemplate {
    className: string;
    fieldGroup: any;
};

export interface IQuestionTemplate {
    className: string;
    key?: string;
    name?: string;
    defaultValue?: any;
    wrapper?: string[];
    type: string;
    templateOptions: Object;
    hideExpression?: any;
    expressionProperties?: Object;
    validators: IQuestionValidator;
    validation?: IQuestionValidation;
    parsers?: any[];
};

export interface IQuestionValidation {
  show: boolean;
}

export interface IQuestionValidator {
  validation?: any;
}

export interface IProcessedData {
    config: FormlyFieldConfig[];
    model: Object;
}



// WEBPACK FOOTER //
// ./src/app/shared/types/formly.ts